import "es6-promise/auto";



//////////////////
// WEBPACK FOOTER
// ./app/shared/polyfills/promise.ts
// module id = t4Id
// module chunks = 2